import { toQueryParams } from "utils/http/params";
import { dataApi } from "./DataService";
import { getQueryCacheKey } from "rtkq/getQueryCacheKey";
import { markEndpointStale } from "rtkq/staleManager";

const profileApi = dataApi
  .enhanceEndpoints({addTagTypes: ['profile']})
  .injectEndpoints({
    endpoints: (builder) => ({

      getProfiles: builder.query({
        query: (arg) => ({
          url: '/profiles',
          params: toQueryParams(arg)
        }),
        transformResponse: (response, meta, arg) => {
            const editedItems = response.body.items.map( item => {
              if(item.licenceRequired === undefined) {
                item.licenceRequired = false;
              }
              if(item.trial === undefined) {
                item.trial = '';
              }
              return item;
            });
            
            response.body.items = editedItems;
            return response;
        },
        providesTags: ['profile']
      }),

      getProfileApps: builder.query({
        query: ({profileName}) => ({
          url: `/profiles/${encodeURIComponent(profileName)}`,
          params: toQueryParams({mode: 'apps'})
        })
      }),

      getProfileRanges: builder.query({
        query: ({profileName}) => ({
          url: `/profiles/${encodeURIComponent(profileName)}`,
          params: toQueryParams({mode: 'ranges'})
        })
      }),

      updateProfile: builder.mutation({
        query: ({id, body}) => ({
          url: `/profiles/${encodeURIComponent(id)}`,
          method: 'PATCH',
          body: body
        }),
        async onQueryStarted({id, body: {apps, ranges, ...profileParams}, currentQueryArgs}, {dispatch, queryFulfilled}) {
          
          let patchProfiles = null, patchApps = null, patchRanges = null, patchDefaultApp = null; 

          //если менялись общие параметры профиля 
          Object.keys(profileParams).length && (patchProfiles = dispatch( 
            profileApi.util.updateQueryData('getProfiles', currentQueryArgs, (draft) => { 
              let item = draft?.body?.items.find(el => el.id === id);  
              item && Object.assign(item, profileParams); 
            })
          ));

          //если менялось значение по-умолчанию для всех приложений профиля
          if (profileParams.default) {
            patchDefaultApp = dispatch(
              profileApi.util.updateQueryData('getProfileApps', {profileName: id}, (draft) => {
                draft.body['default'] = profileParams.default;
              })
            );
          }


          //если менялись доступность приложения профиля или его версия
          
          apps && (patchApps = dispatch(
            profileApi.util.updateQueryData('getProfileApps', {profileName: id}, (draft) => {
              apps.forEach(el => {
                const index = draft.body.items.findIndex(item => item.package === el.package);
                const {package: packageName, ...edited} = el;
                
                if(index !== -1)   {
                  draft.body.items[index] = {...draft.body.items[index], ...edited};
                }
                else {
                  draft.body.items.unshift(el);
                }

              });
            })
          ));

          //если менялись диапазоны заводских номеров профиля
          ranges && (patchRanges = dispatch(
            profileApi.util.updateQueryData('getProfileRanges', {profileName: id}, (draft) => {  
              ranges.forEach(el => {
                const index = draft.body.items.findIndex(item => item.id === el.id);
                if(index !== -1) { 
                  el.deleted ? draft.body.items.splice(index, 1) : draft.body.items[index] = {...draft.body.items[index], ...el}; 
                }
                else {
                  draft.body.items.unshift(el);
                }
              });
            })
          ));

          try {
            const { data } = await queryFulfilled; 

            ranges && (patchRanges = dispatch(
              profileApi.util.updateQueryData('getProfileRanges', {profileName: id}, (draft) => {
                data.body?.ranges?.items.forEach(el => { 
                  if(el['action'] === 'add') {
                    const index = draft.body.items.findIndex(item => item.id === el.oldId); 
                    if(index !== -1) {
                      draft.body.items[index].id = el.newId;
                    }
                  }
                });
              })
            ));

            //если есть фильтрация + изменяемое поле в body задействовано при фильтрации, то обновляем и текущий кэш
            const currentCacheKey = getQueryCacheKey({endpointName: 'getProfiles', queryArgs: currentQueryArgs, patchData: profileParams});
            dispatch(
                markEndpointStale({
                    endpointName: 'getProfiles',
                    exceptCacheKey: currentCacheKey
                })
            );

          }
          catch { 
            patchProfiles && patchProfiles.undo();
            patchApps && patchApps.undo();
            patchRanges && patchRanges.undo();
            patchDefaultApp && patchDefaultApp.undo();
          }
        }
      }),

      addProfile: builder.mutation({
        query: ({body}) => ({
            url: `/profiles`,
            method: 'POST',
            body: body
        })
      }),

      deleteProfile: builder.mutation({
        query: ({id}) => ({
          url: `/profiles/${encodeURIComponent(id)}`,
          method: 'DELETE'
        }),
        async onQueryStarted({id, currentQueryArgs}, {dispatch, queryFulfilled}) {
          const result = dispatch(
            profileApi.util.updateQueryData('getProfiles', currentQueryArgs, (draft) => {
              const index = draft.body.items.findIndex(item => item.id === id);
              draft.body.items.splice(index, 1);
            })
          );
          try {
            await queryFulfilled;
            const currentCacheKey = getQueryCacheKey({endpointName: 'getProfiles', queryArgs: currentQueryArgs});
            dispatch(
                markEndpointStale({
                    endpointName: 'getProfiles',
                    exceptCacheKey: currentCacheKey
                })
            );
          }
          catch {
            result.undo();
          }
        }
      })
    })
  });

export const {
  useGetProfilesQuery,
  useGetProfileAppsQuery,
  useGetProfileRangesQuery,
  useUpdateProfileMutation,
  useAddProfileMutation,
  useDeleteProfileMutation
} = profileApi;  
